import { useMemo } from "react";
import { useApi, apiResolver } from "@/api/useApi";
import {
  CreateTrainingSessionEventRequest,
  GetTrainingSessionEventsRequest,
  GetTrainingSessionEventsResponse,
  TrainingSessionEvent,
} from "./TrainingSessionEvent.model";

export function useTrainingSessionEventApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      createEvent: async (input: CreateTrainingSessionEventRequest) =>
        apiResolver<TrainingSessionEvent>(
          api.post("/platform/training-session-events", input)
        ),
      getEvents: async (params: GetTrainingSessionEventsRequest = {}) => {
        const queryParams = new URLSearchParams();

        if (params.simulatorId) {
          queryParams.append("simulatorId", params.simulatorId.toString());
        }

        if (params.releaseIds && params.releaseIds.length > 0) {
          params.releaseIds.forEach((id) => {
            queryParams.append("releaseIds[]", id.toString());
          });
        }

        if (params.topicIds && params.topicIds.length > 0) {
          params.topicIds.forEach((id) => {
            queryParams.append("topicIds[]", id.toString());
          });
        }

        if (params.eventTypes && params.eventTypes.length > 0) {
          params.eventTypes.forEach((type) => {
            queryParams.append("eventTypes[]", type);
          });
        }

        if (params.startDate) {
          queryParams.append("startDate", params.startDate);
        }

        if (params.endDate) {
          queryParams.append("endDate", params.endDate);
        }

        if (params.userId) {
          queryParams.append("userId", params.userId);
        }

        if (params.page) {
          queryParams.append("page", params.page.toString());
        }

        queryParams.append("includeSessionsCount", true.toString());
        queryParams.append("includeBadFeedbackCount", true.toString());
        queryParams.append("includeGoodSessionCount", true.toString());

        return apiResolver<GetTrainingSessionEventsResponse>(
          api.get(
            `/platform/training-session-events${
              queryParams.toString() ? `?${queryParams.toString()}` : ""
            }`
          )
        );
      },
    }),
    [api]
  );
}
